module.exports = __webpack_public_path__ + "static/media/last_page_black_24dp.49683ffa.svg";